<script>
import AdoptionsService from "@/services/adoptions.service";

export default {
  name: "UnresponsiveClientsThirdAttempt",
  props: {
    entityId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loading: false,
    status: 9,
    selectedClients: [],
    clients: [],
    headers: [
      {
        text: 'Client',
        value: 'client',
        filterable: true
      },
      {
        text: 'EIN',
        value: 'ein',
        filterable: true
      },
      {
        text: 'Legal Name',
        value: 'legal_name',
        filterable: true
      },
      {
        text: 'Date contact initiated',
        value: 'date',
      }
    ],

  }),
  methods: {
    handleRowClick(item) {
      this.$router.push(
        {
          path: `/clients/${ item.id }/emails`,
          query: { adopterId: this.entityId },
        },
      );
    },
    async getData() {
      this.loading = true

      try {
        this.clients = await AdoptionsService.getAdoptionStatus(this.entityId, this.status)
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    await this.getData()
  }
};
</script>

<template>
  <div>
    <v-row>
      <v-col cols="12" md="10">
        <v-card>
          <v-card-text>
            <p>Click on a client’s row to visit their page and resend their introduction email.</p>
            <v-data-table
              :headers="headers"
              :items="clients"
              @click:row="handleRowClick"
              v-model="selectedClients"
              :loading="loading"
              disable-pagination
              hide-default-footer
            />
          </v-card-text>
<!--          <v-card-actions>-->
<!--            <div class="d-flex justify-center" style="width: 100%">-->
<!--              <v-btn color="primary" @click="ResendIntroLetter" :disabled="!selectedClients.length">Resend Introduction letter</v-btn>-->
<!--            </div>-->
<!--          </v-card-actions>-->
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>